import React from "react"
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import "./index.css"
import { applyAdminTheme } from "./theme/applyAdminTheme";
import App from "./App";

applyAdminTheme();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter basename={"/"}>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/invite" element={<App />} />
        <Route path="/g" element={<App />} />
        <Route path="/g/*" element={<App />} />
        <Route path="/a/accounts/:accountId/*" element={<App />} />
        <Route
          path="/a/accounts/:accountId/spaces/:spaceId/*"
          element={<App />}
        />
        <Route
          path="/e/accounts/:accountId/events/:eventId/*"
          element={<App />}
        />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
)
